// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/AddAction/Add/Content/Procedures/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Charges_AddAction_Add_Content_Procedures($location_id: uuid!) {
  vaxiom_procedures(
    where: { organization: { _id: { _eq: $location_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    id
    text: name
  }
}

`